angular.module("config", [])

.constant("ENV", {
	"NAME": "production",
	"IEV_URL": "/api-proxy/api/chouette/1.0",
	"API_URL": "/api-proxy/api/offre/1.0",
	"API_UPDATE_OKINA_APP": "https://jcvd.okina.fr/",
	"BACKEND_PUBLIC_OPEN_DATA": "public/open-iti/#/data",
	"SENTRY_URL": "https://f6e43b56ea4749fabb74d8fd214a0882@sentry.okina.fr/4",
	"TIMETABLE_ADMIN_BASE_URL": "/api-proxy/api/timetable_admin/1.0/",
	"EVENTS_BASE_URL": "/api-proxy/api/events/1.0/",
	"LOGGING_BASE_URL": "/api-proxy/api/logging-service/1.0/",
	"TIAMAT_BASE_URL": "/api-proxy/api/stop_places/1.0/",
	"PROVIDERS_BASE_URL": "/api-proxy/api/providers/1.0/",
	"FARES_BASE_URL": "/api-proxy/api/fares_referential/1.0/",
	"CLOUD_FILE_URL": "EMPTY_URL",
	"SIMULATION_CHECK_URL": "https://www.google.com",
	"MVN_VERSION": "3.7.2-mobi-iti-open-source",
	"COMMON_DIRECTIVES_URL": "",
	"FLEX_BASE_URL": "/api-proxy/api/flexible-lines/1.0/"
})

;